define('models/pages/wishlist/wishes/wishlist-item',['require','underscore','chaplin','models/base/model'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Model = require('models/base/model');

    function shrink(value) {
        if (value) {
            var parts = value.split('и еще');
            if (parts.length > 1) {
                value = parts[0] + '...';
            }
        } else {
            value = 'Все';
        }
        return value;
    }

    function shrinkValue(item, fieldName) {
        try {
            item[fieldName + 'Short'] = shrink(item[fieldName]);
        } catch(e) {
            console.log(fieldName, e);
        }
    }

    var WishlistItem = Model.extend({
        idAttribute: 'id',
        urlPath: function() {
            var id = this.get(this.idAttribute);
            return '/api/wishlist' + (id ? ('/' + id) : '');
        },
        parse: function(item) {
            shrinkValue(item, 'vendors');
            shrinkValue(item, 'lengths');
            if (item.favoriteSellers) {
                item.sellers = 'Избранные';
            } else {
                shrinkValue(item, 'sellers');
            }
            if (item.favoriteGoods) {
                item.goods = 'Избранные';
            } else {
                shrinkValue(item, 'goods');

            }
            return item;
        }
    });

    return WishlistItem;
});

